const isFiniteNumber = (value: number | null | undefined): value is number => {
  return typeof value === 'number' && Number.isFinite(value)
}

/** `reimbursementAmount` is integer cents on the wire; the form edits dollars. */
export const centsToDollarsInput = (cents: number | null | undefined): string => {
  if (!isFiniteNumber(cents)) {
    return ''
  }

  return (cents / 100).toFixed(2)
}

/** `Math.round` so `19.99 * 100 = 1998.9999…` still sends 1999. Blank is 0, as the DTO transform does. */
export const dollarsInputToCents = (value: string): number => {
  const trimmed = value.trim()

  if (trimmed === '') {
    return 0
  }

  return Math.round(Number(trimmed) * 100)
}

export const formatCents = (cents: number | null | undefined): string => {
  if (!isFiniteNumber(cents)) {
    return '—'
  }

  return `$${(cents / 100).toFixed(2)}`
}

/** `reimbursementPercentage` is `decimal(4,2)` with no transformer, so it can arrive as "12.50". */
export const toPercentageNumber = (value: number | string | null | undefined): number | null => {
  if (value === null || value === undefined || value === '') {
    return null
  }

  const parsed = Number(value)

  if (!Number.isFinite(parsed)) {
    return null
  }

  return parsed
}

export const percentageToInput = (value: number | string | null | undefined): string => {
  const parsed = toPercentageNumber(value)

  if (parsed === null) {
    return ''
  }

  return String(parsed)
}

export const formatPercentage = (value: number | string | null | undefined): string => {
  const parsed = toPercentageNumber(value)

  if (parsed === null) {
    return '—'
  }

  return `${parsed}%`
}
